<script setup>

import { defineProps, ref, watch } from 'vue';

const props = defineProps({
    article: {
        type: Object,
        required: true
    }
})

const tags = ref([]);

const updateTags = () => {
    tags.value = [];
    ['programmes', 'themes', 'phases'].forEach((key) => {
        if (props.article[key]) {
            tags.value.push(...props.article[key]);
        }
    });
};

updateTags();

watch(() => props.article, updateTags, { deep: true });

</script>

<template>
    <div class="m-listing-articles__card" data-article="mouseover">
        <div class="c-card-page">
            <div class="c-card-page__image">
                <img :src="props.article.card_img.sizes.large" :alt="props.article.title" />
            </div>

            <div class="c-card-page__content">
                <h3 class="c-medium-heading c-card-page__title">
                    <a class="c-card-page__link" :href="props.article.url" v-html="props.article.title"></a>
                </h3>

                <div class="c-card-page__intro">
                    {{ props.article.intro }}
                </div>

                <div class="c-card-page__tags">
                    <template v-for="tag in tags" :key="tag">
                        <div v-if="tag" class="c-card-page__tag-wrapper">
                            <span class="c-card-page__tag c-card-page__tag--article">{{ tag }}</span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>